const Subdomain = {
  DEV: 'dev',
  STAGING: 'staging',
}

export enum ENVIRONMENT {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
}

// Production: getty.prod.getty.do.artpro.co OR getty.artpro.io
const prodPattern = /^(getty\.prod\.getty\.do\.artpro\.co|getty\.artpro\.io)$/
// Staging: contains 'staging' in the domain
const stagingPattern = /staging/
// Dev: contains 'dev' in the domain
const devPattern = /dev\.artpro\.io$/

const determineEnvironmentFromHostDomain = () => {
  const host = window.location.hostname;
  return host.match(prodPattern) ? ENVIRONMENT.PROD 
    : host.match(stagingPattern) ? ENVIRONMENT.STAGING 
    : host.match(devPattern) ? ENVIRONMENT.DEV 
    : ENVIRONMENT.LOCAL
}

const appEnvironment = determineEnvironmentFromHostDomain();

console.log("Application Environment = ", appEnvironment )
export {appEnvironment}